import React from 'react';

import SortIcon from '../SortIcon';
import { useUserStore } from '../../../store';

export default function HiringPipelineSubHeadings({
  col,
  index,
  classes,
  changeSortSettings,
  sortOrder,
  activeSortOption,
}) {
  const screeningAvailable = useUserStore((state) => state.screeningAvailable);
  const isAgency = useUserStore((state) => state.isAgency);
  const isClient = useUserStore((state) => state.isClient);

  return (
    <>
      {!isClient && (
        <th
          // eslint-disable-next-line react/no-array-index-key
          key={`${col.field}${index}`}
          className={classes.thHiringPipelineHeading}
          onClick={() => changeSortSettings('summary.new')}
        >
          <div className={classes.thContainer}>
            New{' '}
            <SortIcon
              sortOrder={sortOrder}
              activeSortOption={{ label: activeSortOption.value }}
              name="summary.new"
            />
          </div>
        </th>
      )}
      {screeningAvailable && !isClient && (
        <th
          key={`${col.field}990`}
          className={classes.thHiringPipelineHeading}
          onClick={() => changeSortSettings('summary.screen')}
        >
          <div className={classes.thContainer}>
            Screen{' '}
            <SortIcon
              style={{ right: 0 }}
              sortOrder={sortOrder}
              activeSortOption={{ label: activeSortOption.value }}
              name="summary.screen"
            />
          </div>
        </th>
      )}
      {!isClient && (
        <th
          key={`${col.field}991`}
          className={classes.thHiringPipelineHeading}
          onClick={() => changeSortSettings('summary.interview')}
        >
          <div className={classes.thContainer}>
            Interview{' '}
            <SortIcon
              style={{ right: 0 }}
              sortOrder={sortOrder}
              activeSortOption={{ label: activeSortOption.value }}
              name="summary.interview"
            />
          </div>
        </th>
      )}
      {(isAgency || isClient) && (
        <th
          key={`${col.field}992`}
          className={classes.thHiringPipelineHeading}
          onClick={() => changeSortSettings('summary.clientSubmit')}
        >
          <div className={classes.thContainer}>
            {isClient ? 'New' : 'Submit'}{' '}
            <SortIcon
              sortOrder={sortOrder}
              activeSortOption={{ label: activeSortOption.value }}
              name="summary.clientSubmit"
            />
          </div>
        </th>
      )}
      {(isAgency || isClient) && (
        <th
          key={`${col.field}993`}
          className={classes.thHiringPipelineHeading}
          onClick={() => changeSortSettings('summary.clientInterview')}
        >
          <div className={classes.thContainer}>
            Interview{' '}
            <SortIcon
              sortOrder={sortOrder}
              activeSortOption={{ label: activeSortOption.value }}
              name="summary.clientInterview"
            />
          </div>
        </th>
      )}
      <th
        key={`${col.field}994`}
        className={classes.thHiringPipelineHeading}
        onClick={() => changeSortSettings('summary.offer')}
      >
        <div className={classes.thContainer}>
          Offer{' '}
          <SortIcon
            sortOrder={sortOrder}
            activeSortOption={{ label: activeSortOption.value }}
            name="summary.offer"
          />
        </div>
      </th>
      <th
        key={`${col.field}995`}
        className={classes.thHiringPipelineHeading}
        onClick={() => {
          changeSortSettings('summary.onboard');
        }}
      >
        <div className={classes.thContainer}>
          Onboard{' '}
          <SortIcon
            style={{ right: 0 }}
            sortOrder={sortOrder}
            activeSortOption={{ label: activeSortOption.value }}
            name="summary.onboard"
          />
        </div>
      </th>
    </>
  );
}
